<template>
  <div>
    <b-col md="12">
      <div>
        <b-modal
          :no-close-on-backdrop="true"
          :id="`modal-confirm-print`"
          :title="$t('surgery.print-invoice')"
          ok-only
          :ok-title="$t('common.print')"
          @ok="printInvoice"
        >
          <b-card-text>
            <h5>{{ $t("surgery.print-invoice") }}</h5>
            {{ $t("surgery.print-sure") }}
          </b-card-text>
        </b-modal>

        <!-- add surgery invoice modal -->
        <b-modal
          :no-close-on-backdrop="true"
          id="add-surgery-invoice-modal"
          :title="
            isEditing
              ? $t('hospital.update-surgery-invoice')
              : $t('hospital.create-surgery-invoice')
          "
          ok-only
          size="lg"
          :ok-title="isEditing ? $t('common.update') : $t('common.add')"
        >
          <template #modal-footer="{}">
            <b-button
              variant="primary"
              @click="submitItem"
              class="m-0"
              :disabled="loading"
              ref="button"
              block
            >
              <span v-if="!loading">{{
                isEditing ? $t("common.update") : $t("common.add")
              }}</span>
              <b-spinner small v-else></b-spinner>
            </b-button>
          </template>
          <b-card-text>
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('surgery.surgery-perant')"
                  class="required"
                >
                  <v-select
                    v-model="EditForm.patient_card_surgery_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :clearable="false"
                    label="title"
                    :options="surgeryList"
                    :reduce="(option) => option.value"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.patient_card_surgery_id }}
                  </p>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.room_amount')"
                  label-for="room_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="room_amount"
                    v-model="EditForm.room_amount"
                    :placeholder="$t('surgery.room_amount')"
                  />
                  <p class="text-danger mt-1">{{ errorForm.room_amount }}</p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.admin_services_amount')"
                  label-for="admin_services_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="admin_services_amount"
                    v-model="EditForm.admin_services_amount"
                    :placeholder="$t('surgery.admin_services_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.admin_services_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.general_services_amount')"
                  label-for="general_services_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="general_services_amount"
                    v-model="EditForm.general_services_amount"
                    :placeholder="$t('surgery.general_services_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.general_services_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.nursing_amount')"
                  label-for="nursing_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="nursing_amount"
                    v-model="EditForm.nursing_amount"
                    :placeholder="$t('surgery.nursing_amount')"
                  />
                  <p class="text-danger mt-1">{{ errorForm.nursing_amount }}</p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.surgery_room_amount')"
                  label-for="surgery_room_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="surgery_room_amount"
                    v-model="EditForm.surgery_room_amount"
                    :placeholder="$t('surgery.surgery_room_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.surgery_room_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.labour_room_amount')"
                  label-for="labour_room_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="labour_room_amount"
                    v-model="EditForm.labour_room_amount"
                    :placeholder="$t('surgery.labour_room_amount')"
                    class="required"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.labour_room_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.medical_consumables_amount')"
                  label-for="medical_consumables_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="medical_consumables_amount"
                    v-model="EditForm.medical_consumables_amount"
                    :placeholder="$t('surgery.medical_consumables_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.medical_consumables_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.pre_incubator_amount')"
                  label-for="pre_incubator_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="pre_incubator_amount"
                    v-model="EditForm.pre_incubator_amount"
                    :placeholder="$t('surgery.pre_incubator_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.pre_incubator_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="6">
                <b-form-group
                  :label="$t('surgery.pre_cpap_amount')"
                  label-for="pre_cpap_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="pre_cpap_amount"
                    v-model="EditForm.pre_cpap_amount"
                    :placeholder="$t('surgery.pre_cpap_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.pre_cpap_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="6">
                <b-form-group
                  :label="$t('surgery.scanner_device_amount')"
                  label-for="scanner_device_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="scanner_device_amount"
                    v-model="EditForm.scanner_device_amount"
                    :placeholder="$t('surgery.scanner_device_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.scanner_device_amount }}
                  </p>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <hr style="border-top: 1px solid #000; margin: 20px 0" />
              </b-col>
              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.surgeon_amount')"
                  label-for="surgeon_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="surgeon_amount"
                    v-model="EditForm.surgeon_amount"
                    :placeholder="$t('surgery.surgeon_amount')"
                  />
                  <p class="text-danger mt-1">{{ errorForm.surgeon_amount }}</p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.surgery_nurse_assist_amount')"
                  label-for="surgery_nurse_assist_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="surgery_nurse_assist_amount"
                    v-model="EditForm.surgery_nurse_assist_amount"
                    :placeholder="$t('surgery.surgery_nurse_assist_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.surgery_nurse_assist_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.surgeon_assist_amount')"
                  label-for="surgeon_assist_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="surgeon_assist_amount"
                    v-model="EditForm.surgeon_assist_amount"
                    :placeholder="$t('surgery.surgeon_assist_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.surgeon_assist_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.anesthetist_amount')"
                  label-for="anesthetist_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="anesthetist_amount"
                    v-model="EditForm.anesthetist_amount"
                    :placeholder="$t('surgery.anesthetist_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.anesthetist_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.anaesthetist_assist_amount')"
                  label-for="anaesthetist_assist_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="anaesthetist_assist_amount"
                    v-model="EditForm.anaesthetist_assist_amount"
                    :placeholder="$t('surgery.anaesthetist_assist_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.anaesthetist_assist_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.pre_test_amount')"
                  label-for="pre_test_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="pre_test_amount"
                    v-model="EditForm.pre_test_amount"
                    :placeholder="$t('surgery.pre_test_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.pre_test_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.tissue_transplant_amount')"
                  label-for="tissue_transplant_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="tissue_transplant_amount"
                    v-model="EditForm.tissue_transplant_amount"
                    :placeholder="$t('surgery.tissue_transplant_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.tissue_transplant_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.op_nurse_amount')"
                  label-for="op_nurse_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="op_nurse_amount"
                    v-model="EditForm.op_nurse_amount"
                    :placeholder="$t('surgery.op_nurse_amount')"
                    class="required"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.op_nurse_amount }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.consultation_amount')"
                  label-for="consultation_amount"
                  class="required"
                >
                  <b-form-input
                    type="number"
                    id="consultation_amount"
                    v-model="EditForm.consultation_amount"
                    :placeholder="$t('surgery.consultation_amount')"
                  />
                  <p class="text-danger mt-1">
                    {{ errorForm.consultation_amount }}
                  </p>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group
                  :label="$t('common.date')"
                  label-for="date"
                  class="required"
                >
                  <b-form-input
                    :disabled="true"
                    type="datetime"
                    id="date"
                    v-model="date"
                    :placeholder="$t('common.date')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-modal>
        <b-card>
          <b-row>
            <b-col md="4" cols="6">
              <b-form-group :label="$t('common.from-date')" label-for="date">
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="dateFrom"
                  class="mb-2"
                  today-button
                  reset-button
                  close-button
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="6">
              <b-form-group :label="$t('common.to-date')" label-for="date">
                <b-form-datepicker
                  id="example-datepicker2"
                  v-model="dateTo"
                  class="mb-2"
                  today-button
                  reset-button
                  close-button
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-2 mt-1">
            <b-col md="4" cols="6">
              <b-form-group
                :label="$t('common.hospital-net-amount-sum')"
                label-for="name"
              >
                <h3>
                  <b-badge variant="primary">{{
                    formatIQDCurrency(sums.hospital_net_amount_sum)
                  }}</b-badge>
                </h3>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="6">
              <b-form-group
                :label="$t('common.total-amount-sum')"
                label-for="name"
              >
                <h3>
                  <b-badge variant="primary">{{
                    formatIQDCurrency(sums.total_amount_sum)
                  }}</b-badge>
                </h3>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="12">
              <b-button
                class="float-right"
                variant="primary"
                @click="getPatientSurgeriesInvoices()"
              >
                {{ $t("common.search") }}
               </b-button>
            </b-col>
            <b-col md="4" cols="6">
              <p class="text-muted font-weight-bold">
                {{ $t("common.this-sums-based-on-the-selected-date") }}
              </p>
            </b-col>
          </b-row>

          <div>
            <!-- Data Table  -->
            <div class="d-flex justify-content-between mt-4 mb-2">
              <h2>{{ $t("common.invoices") }}</h2>
              <b-button
                v-if="$route.query.patientCardId"
                @click="openAddModal()"
                variant="primary"
                class="p-1 mb-1"
              >
                {{ $t("hospital.create-surgery-invoice") }}
              </b-button>
            </div>
            <b-table
              :items="splitDummyData1"
              responsive
              :fields="tableColumns1"
              primary-key="id"
              show-empty
              :current-page="page"
              :per-page="take"
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(edit)="data">
                <b-button
                  @click="editInvoice(data.item)"
                  variant="outline-warning"
                  size="sm"
                  class="mx-1"
                >
                  {{ $t("common.edit") }}
                </b-button></template
              >
              <template #cell(service)="data">
                <span class="text-nowrap"> Opearation </span>
              </template>
              <template #cell(amount)="data">
                <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
              </template>
              <template #cell(date)="data">
                <span class="text-nowrap"> {{ data.item.date }} </span>
              </template>
              <template #cell(status)="data">
                <div>
                  <ChangeInvoiceStatusDropDown
                    name="surgeryInvoice"
                    @onEmit="$emit('onChangeStatus')"
                    endpoint="invoicePatientSergury"
                    :data="data.item"
                  />
                </div>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div
                  v-if="data.item.status === 'approved'"
                  class="text-nowrap d-flex"
                >
                  <b-button
                    @click="showModal(data.item)"
                    variant="outline-primary"
                    size="sm"
                    class="mx-4"
                  >
                    {{ $t("reception.Print Invoice") }}
                  </b-button>
                  <b-button
                    ref="surgeryInvoiceRef"
                    v-print="ServicesInvoiceBtn"
                    variant="outline-primary"
                    size="sm"
                    class="hidden"
                  >
                    {{ $t("reception.Print Invoice") }}
                  </b-button>
                </div>
              </template>
              <template #cell(show_more)="data">
                <b-button
                  v-b-modal="`my-modal-${data.index}`"
                  variant="outline-primary"
                  size="sm"
                >
                  {{ $t("common.show_more") }}
                </b-button>
                <b-modal
                  :id="`my-modal-${data.index}`"
                  ref="popover"
                  class="popover-custom-width"
                  size="xl"
                  scrollable
                  ok-only
                >
                  <b-table
                    :items="[data.item]"
                    :fields="tableColumns2"
                    primary-key="id"
                    show-empty
                    responsive
                    :per-page="take"
                    :current-page="page"
                    empty-text="No matching results found"
                    class="position-relative"
                    v-if="!loading"
                  >
                    <template #cell(service)="data">
                      <span class="text-nowrap"> Opearation </span>
                    </template>
                    <template #cell(amount)="data">
                      <span class="text-nowrap">
                        {{ data.item.amount }} IQD
                      </span>
                    </template>
                    <template #cell(status)="data">
                      <div>
                        <ChangeInvoiceStatusDropDown
                          name="surgeryInvoice"
                          @onEmit="$emit('onChangeStatus')"
                          endpoint="invoicePatientSergury"
                          :data="data.item"
                        />
                      </div>
                    </template>
                    <!-- Column: Actions -->
                    <template #cell(actions)="data">
                      <div
                        v-if="
                          data.item.status === 'approved'  
                        "
                        class="text-nowrap d-flex"
                      >
                        <b-button
                          @click="showModal(data.item)"
                          variant="outline-primary"
                          size="sm"
                          class="mx-4"
                        >
                          {{ $t("reception.Print Invoice") }}
                        </b-button>
                        <b-button
                          ref="surgeryInvoiceRef"
                          v-print="ServicesInvoiceBtn"
                          variant="outline-primary"
                          size="sm"
                          class="hidden"
                        >
                          {{ $t("reception.Print Invoice") }}
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-modal>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getInvoices()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </div>
      <ServicesInvoice :patientData="patientData" :data="invoice" />
    </b-col>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BModal,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BBadge,
  BFormDatepicker,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Datepicker from "vuejs-datepicker";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const ServicesInvoice = () =>
  import("@/components/printables/ServicesInvoice.vue");
const ChangeInvoiceStatusDropDown = () =>
  import("@/components/invoices/ChangeInvoiceStatusDropDown.vue");
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import router from "@/router";

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BBadge,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    ToastificationContent,
    Datetime,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    Datepicker,
    BFormDatepicker,
    ChangeInvoiceStatusDropDown,
    ServicesInvoice,
    AutoComplete,
  },
  data() {
    return {
      tableColumns1: [
        {
          key: "edit",
          label: this.$t("common.edit"),
        },
        {
          key: "invoice_no",
          label: this.$t("surgery.invoice_no"),
          sortable: true,
        },
        {
          key: "date",
          label: this.$t("common.date"),
          sortable: true,
        },
        {
          key: "room_amount",
          label: this.$t("surgery.room_amount"),
          sortable: true,
        },
        {
          key: "admin_services_amount",
          label: this.$t("surgery.admin_services_amount"),
          sortable: true,
        },
        {
          key: "general_services_amount",
          label: this.$t("surgery.general_services_amount"),
          sortable: true,
        },
        {
          key: "nursing_amount",
          label: this.$t("surgery.nursing_amount"),
          sortable: true,
        },
        {
          key: "surgery_nurse_assist_amount",
          label: this.$t("surgery.surgery_nurse_assist_amount"),
          sortable: true,
        },
        {
          key: "surgery_room_amount",
          label: this.$t("surgery.surgery_room_amount"),
          sortable: true,
        },
        {
          key: "labour_room_amount",
          label: this.$t("surgery.labour_room_amount"),
          sortable: true,
        },
        {
          key: "medical_consumables_amount",
          label: this.$t("surgery.medical_consumables_amount"),
          sortable: true,
        },
        {
          key: "pre_incubator_amount",
          label: this.$t("surgery.pre_incubator_amount"),
          sortable: true,
        },

        {
          key: "show_more",
          label: this.$t("common.show_more"),
        },
      ],

      tableColumns2: [
        {
          key: "invoice_no",
          label: this.$t("surgery.invoice_no"),
          sortable: true,
        },

        {
          key: "pre_cpap_amount",
          label: this.$t("surgery.pre_cpap_amount"),
          sortable: true,
        },
        {
          key: "scanner_device_amount",
          label: this.$t("surgery.scanner_device_amount"),
          sortable: true,
        },
        {
          key: "surgeon_amount",
          label: this.$t("surgery.surgeon_amount"),
          sortable: true,
        },
        {
          key: "surgeon_assist_amount",
          label: this.$t("surgery.surgeon_assist_amount"),
          sortable: true,
        },
        {
          key: "anesthetist_amount",
          label: this.$t("surgery.anesthetist_amount"),
          sortable: true,
        },
        {
          key: "anaesthetist_assist_amount",
          label: this.$t("surgery.anaesthetist_assist_amount"),
          sortable: true,
        },
        {
          key: "pre_test_amount",
          label: this.$t("surgery.pre_test_amount"),
          sortable: true,
        },
        {
          key: "tissue_transplant_amount",
          label: this.$t("surgery.tissue_transplant_amount"),
          sortable: true,
        },
        {
          key: "op_nurse_amount",
          label: this.$t("surgery.op_nurse_amount"),
          sortable: true,
        },
        {
          key: "consultation_amount",
          label: this.$t("surgery.consultation_amount"),
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("common.status"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],

      invoiceLatestStatus: "",
      InvoiceId: "",
      invoice: {},
      ServicesInvoiceBtn: {
        id: "ServicesInvoice",
      },
      EditForm: {
        patient_card_surgery_id: "",
        room_amount: "",
        admin_services_amount: "",
        general_services_amount: "",
        nursing_amount: "",
        surgery_nurse_assist_amount: "",
        surgery_room_amount: "",
        labour_room_amount: "",
        medical_consumables_amount: "",
        pre_incubator_amount: "",
        pre_cpap_amount: "",
        scanner_device_amount: "",
        surgeon_amount: "",
        surgeon_assist_amount: "",
        anesthetist_amount: "",
        anaesthetist_assist_amount: "",
        pre_test_amount: "",
        tissue_transplant_amount: "",
        op_nurse_amount: "",
        consultation_amount: "",
        date: "",
      },
      date: new Date().toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: "Asia/Baghdad",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }),

      errorForm: {
        patient_card_surgery_id: "",
        room_amount: "",
        admin_services_amount: "",
        general_services_amount: "",
        nursing_amount: "",
        surgery_nurse_assist_amount: "",
        surgery_room_amount: "",
        labour_room_amount: "",
        medical_consumables_amount: "",
        pre_incubator_amount: "",
        pre_cpap_amount: "",
        scanner_device_amount: "",
        surgeon_amount: "",
        surgeon_assist_amount: "",
        anesthetist_amount: "",
        anaesthetist_assist_amount: "",
        pre_test_amount: "",
        tissue_transplant_amount: "",
        op_nurse_amount: "",
        consultation_amount: "",
        date: "",
      },
      params: {
        form: {},
        path: "",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      dataCount: 10,
      surgeryList: [],
      loading: false,
      take: 10,
      splitDummyData1: [],
      splitDummyData2: [],
      dateTo: "",
      dateFrom: "",
      sums: {
        hospital_net_amount_sum: 0,
        total_amount_sum: 0,
      },
      surgeryName: "",
      isEditing: false,
    };
  },
  props: [
    "invoices",
    "patientData",
    "patientSurgeryId",
    "getData",
    "patient_card_surgery_id",
  ],

  mounted() {
    const today = new Date();
    this.dateFrom = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-01`;
    this.getPatientSurgeriesInvoices();
    this.getPatientSurgeryInfo();
    // this.splitDummyData();
    console.log("date", this.date);
    console.log("patientData22", this.patientData);
  },
  methods: {
    formatIQDCurrency(value) {
      // console.log("value", value);
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    formatDate(surgeryDate) {
      const date = new Date(surgeryDate);

      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();
      let hours = "" + date.getHours();
      let minutes = "" + date.getMinutes();
      let seconds = "" + date.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hours.length < 2) hours = "0" + hours;
      if (minutes.length < 2) minutes = "0" + minutes;
      if (seconds.length < 2) seconds = "0" + seconds;

      // Return the formatted date and time string
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    printInvoice() {
      this.$refs.surgeryInvoiceRef.click();
      this.changeStatusToPrinted();
    },
    async showModal(status) {
      await this.getSurgeryName(status.patient_card_surgery.surgery_id);
      this.$bvModal.show("modal-confirm-print");
      this.invoice = status;
      this.invoice.surgery_name = this.surgeryName;
      console.log("invoice", this.invoice);
    },
    async getSurgeryName(surgeryId) {
      await this.getList(`/surgery/${surgeryId}`);
      this.surgeryName = this.all_data.title;
    },
    openAddModal() {
      this.isEditing = false;
      this.EditForm = {
        patient_card_stay_id: this.$route.params.id,
        room_amount: "",
        admin_services_amount: "",
        general_services_amount: "",
        nursing_amount: "",
        surgery_nurse_assist_amount: "",
        labour_room_amount: "",
        medical_consumables_amount: "",
        pre_incubator_amount: "",
        pre_cpap_amount: "",
        scanner_device_amount: "",
        doctor_amount: "",
        doctor_assist_amount: "",
        pre_test_amount: "",
        tissue_transplant_amount: "",
        op_nurse_amount: "",
        consultation_amount: "",
        pre_ventameter_amount: "",
        management_services_amount: "",
        delivery_room_amount: "",
        date: "",
      };
      // Reset error messages
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
      }
      this.$bvModal.show("add-surgery-invoice-modal");
    },
    changeStatusToPrinted() {
      console.log("changeStatusToPrinted");
      (this.params.form = { status: "printed" }),
        (this.params.path = `/invoicePatientSergury/${this.invoice.id}/changeStatus`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getData();
            this.$emit("reloadInvoices");
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `${this.$t("common.success")}`,
                variant: "success",
                text: `${response.data.message}`,
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    // Format a date string from "2025-03-26 13:17:00 pm" to "2025-03-26 13:17:00"
    formatPmDate(dateString) {
      if (!dateString || typeof dateString !== "string") {
        return "";
      }

      // Check if the date string contains 'am' or 'pm'
      if (
        dateString.toLowerCase().includes("am") ||
        dateString.toLowerCase().includes("pm")
      ) {
        const parts = dateString.split(" ");
        if (parts.length >= 3) {
          const datePart = parts[0]; // e.g., 2025-03-26
          const timePart = parts[1]; // e.g., 13:17:00
          const ampm = parts[2].toLowerCase(); // e.g., pm

          // Parse the time
          const [hours, minutes, seconds] = timePart.split(":").map(Number);

          // Convert to 24-hour format if needed
          let hour = hours;
          if (ampm === "pm" && hours < 12) {
            hour = hours + 12;
          } else if (ampm === "am" && hours === 12) {
            hour = 0;
          }

          // Format the time with leading zeros
          const formattedHour = hour < 10 ? `0${hour}` : `${hour}`;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
          const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

          // Return the formatted date and time
          return `${datePart} ${formattedHour}:${formattedMinutes}:${formattedSeconds}`;
        }
      }

      // If the format is not as expected, return the original
      return dateString;
    },
    editInvoice(item) {
      this.isEditing = true;
      this.EditForm = { ...item };
      // Format the date properly if it exists
      if (this.EditForm.date) {
        // Convert from format like "2025-03-26 13:17:00 pm" to "2025-03-26 13:17:00"
        this.EditForm.date = this.formatPmDate(this.EditForm.date);
        this.date = this.EditForm.date;
      }
      // Reset error messages
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
      }
      this.$bvModal.show("add-surgery-invoice-modal");
    },
    submitItem() {
      let count = 0;
      this.loading = true;
      this.EditForm.date = this.formatDate(this.date);
      this.EditForm.pre_ventameter_amount = 0;
      this.EditForm.management_services_amount = 0;
      this.EditForm.pre_ventameter_amount = 0;
      this.EditForm.delivery_room_amount = 0;

      // Reset all error messages
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null) {
          delete this.EditForm[item];
          count++;
          this.errorForm[item] = `The ${item.replace(
            /_/g,
            " "
          )} field is required.`;
        }
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        console.log("errorForm", this.errorForm);
        console.log("count", count);
        this.loading = false;
        return false;
      }

      (this.params.form = this.EditForm),
        (this.params.path = `invoicePatientSergury`),
        this.$store
          .dispatch("create", this.params)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `${this.$t("common.success")}`,
                variant: "success",
              },
            });
            window.location.reload();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async getPatientSurgeryInfo() {
      await this.getPatient(
        `patient-surgery?filter[patient_card_id]=${this.$route.query.patientCardId}&include=surgery&sort=-id`
      );

      this.surgeryList = this.all_data.data.map((item) => ({
        title: item.surgery.title,
        value: item.id,
      }));
      this.EditForm.patient_card_surgery_id = this.surgeryList[0].value;
    },
    async getPatientSurgeriesInvoices() {
      let url = `/invoicePatientSergury?include[]=patientCardSurgery&patient_id=${this.$route.params.patientId}&page=${this.page}&take=${this.take}&sort=-id&filter[date-ge]=${this.dateFrom}&filter[date-le]=${this.dateTo}`;

      await this.getList(url);
      this.dataCount = this.all_data.pagination.total;
      this.sums.hospital_net_amount_sum =
        this.all_data.sums.hospital_net_amount_sum;
      this.sums.total_amount_sum = this.all_data.sums.total_amount_sum;
      this.splitDummyData1 = this.all_data.data;
      this.splitDummyData2 = this.all_data.data;
      console.log("invoices11111", this.splitDummyData1);
      this.loading = false;
    },
    // splitDummyData() {
    //   setTimeout(() => {
    //     // console.log("Original dummyData:", this.dummyData);
    //     // this.splitDummyData1 = [...this.dummyData].map((item) => {
    //     //   let data = {};
    //     //   this.tableColumns1.forEach((column) => {
    //     //     data[column.key] = item[column.key];
    //     //   });
    //     //   return data;
    //     // });
    //     // this.splitDummyData1 = this.dummyData;
    //     this.splitDummyData1 = this.invoices;
    //     this.dataCount = this.invoices.length;

    //     // console.log("Processed splitDummyData1:", this.splitDummyData1);

    //     // this.splitDummyData2 = [...this.dummyData].map((item) => {
    //     //   let data = {};
    //     //   this.tableColumns2.forEach((column) => {
    //     //     data[column.key] = item[column.key];
    //     //   });
    //     //   return data;
    //     // });
    //     // this.splitDummyData2 = this.dummyData;
    //     // this.dataCount = this.dummyData.length;
    //     this.splitDummyData2 = this.invoices;
    //     this.dataCount = this.invoices.length;
    //     // console.log("Processed splitDummyData2:", this.splitDummyData2);
    //   }, 1000);
    // },
  },
};
</script>
